import React, {
    useMemo,
    useState,
    useEffect,
} from 'react';
import { FormattedMessage } from 'react-intl';
import { MantineReactTable } from 'mantine-react-table';
import { useHistory } from 'react-router-dom';
import {
    connect,
    useDispatch,
    useSelector,
} from 'react-redux';
import PageTitle from '../../shared/PageTitle';
import { updateTableDetailsID } from '../../../redux/TableSearch/dataSlice';

const TableSearch = (props) => {
    const searchData = useSelector((state) => state.tableSearch.tableList);
    const dispatch = useDispatch();
    const history = useHistory();
    const handleCellClick = (cell) => {
        const { nRegjistriID } = cell.row.original.table;
        dispatch(updateTableDetailsID(nRegjistriID));
        history.push('/TableDetails');
    };
    const { locale } = props;

    let placeholderTextNameBusiness;
    let placeholderTextNameTrade;
    let placeholderTextNUI
    let placeholderTextMunicipality;
    let placeholderTextStatus;
    let placeholderTextBusinessType;
    if (locale === 'sq') {
        placeholderTextNameBusiness = 'Emri';
        placeholderTextNameTrade = 'Emri tregtar';
        placeholderTextNUI = 'NUI';
        placeholderTextMunicipality = 'Komuna';
        placeholderTextStatus = 'Statusi';
        placeholderTextBusinessType = 'Lloji biznesit';
    } else if (locale === 'en') {
        placeholderTextNameBusiness = 'Name'
        placeholderTextNameTrade = 'Trade Name'
        placeholderTextNUI = 'UIN';
        placeholderTextMunicipality = 'Municipality';
        placeholderTextStatus = 'Status';
        placeholderTextBusinessType = 'Business type';
    } else if (locale === 'sr') {
        placeholderTextNameBusiness = 'Ime'
        placeholderTextNameTrade = 'Trgovačko Ime';
        placeholderTextNUI = 'JMB';
        placeholderTextMunicipality = 'Opština';
        placeholderTextStatus = 'Status';
        placeholderTextBusinessType = 'Poslovni tip'
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: 'table.EmriBiznesit',
                header: [placeholderTextNameBusiness],
                Cell: ({ cell }) => (
                    <button
                        type="button"
                        onClick={() => handleCellClick(cell)}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                        }}
                    >
                        {cell.row.original.table.EmriBiznesit}
                    </button>
                ),
            },
            {
                accessorKey: 'table.EmriTregtar',
                header: [placeholderTextNameTrade],
            },
            {
                accessorKey: 'table.NumriBiznesit',
                header: [placeholderTextNUI],
            },
            {
                accessorKey: 'table.Komuna',
                header: [placeholderTextMunicipality],
            },
            {
                accessorKey: 'table.LlojiBiznesit',
                header: [placeholderTextBusinessType],
            },
            {
                accessorKey: 'table.StatusiARBK',
                header: [placeholderTextStatus],
                size: 100,
            },
        ],
        [],
    );

    const [mappedData, setMappedData] = useState([]);

    useEffect(() => {
        const updatedMappedData = searchData.map((item) => ({
            table: item.teDhenatBiznesit,
        }));
        setMappedData(updatedMappedData);
    }, [searchData]);

    return (
        <div className="TableSearch-section">
            <PageTitle header={<FormattedMessage id="tableSearch.title" defaultMessage="Rezultatet e Bizneseve" />} />
            <div className="table-search" style={{ overflow: 'hidden' }}>
                <MantineReactTable
                    className="mantine-table"
                    columns={columns}
                    data={mappedData ?? []}
                    mantineTableBodyCellProps={({ cell }) => {
                        let className = '';

                        if (cell.row.original.table.StatusiARBK.includes('Pasiv')) {
                            className = 'pasive-cell';
                        } else if (cell.row.original.table.StatusiARBK === 'Shuar') {
                            className = 'shuar-cell';
                        }

                        return {
                            className: className,
                        };
                    }}
                    enableGlobalFilter={false}
                    enableGlobalFilterModes={false}
                    enableFilterMatchHighlighting={false}
                    enableGlobalFilterRankedResults={false}
                    enableBottomToolbar={false}
                    // enableHiding={false}
                    search={false}
                    enableTopToolbar={false}
                    enableColumnFilters={false}
                    // renderTopToolbarCustomActions={() => (
                    //     <h6 className="topbar-table-title">Rrezultatet e Bizneseve</h6>
                    // )}
                    enablePagination={false}
                    state={{ isLoading: false }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(TableSearch);
